export enum UserRoleIds {
    ADMIN = 1,
    BASIC = 2,
}

export enum USER_SCOPES {
    ALL = "*",

    CASHBOX_CATEGORY_READ = "cashbox_category",

    CASHBOX_STATEMENT_READ = "cashbox_statement_read",

    CUSTOMER_READ = "customer_read",

    DASHBOARD = "dashboard",

    EXPENDITURE_RECORD_CREATE = "expenditure_record_create",
    EXPENDITURE_RECORD_READ = "expenditure_record_read",

    PAYABLE_CONTRACT_READ = "payable_contract_read",

    PAYABLE_CONTRACT_DEBIT_READ = "payable_contract_debit_read",

    SERVICE_READ = "service_read",

    SERVICE_CATEGORY_READ = "service_category_read",

    SERVICE_CONTRACT_CREATE = "service_contract_create",
    SERVICE_CONTRACT_READ = "service_contract_read",

    SERVICE_CONTRACT_DEBIT_READ = "service_contract_debit_read",

    SERVICE_CONTRACT_DEBIT_PAYMENT_CREATE = "service_contract_debit_payment_create",
    SERVICE_CONTRACT_DEBIT_PAYMENT_READ = "service_contract_debit_payment_read",

    SETTINGS = "settings",

    USER_READ = "user_read",
}

export class UserPermission {
    constructor() { }

    private dictionaryOfPermissions = {
        [UserRoleIds.ADMIN]: [
            USER_SCOPES.ALL,
        ],
        [UserRoleIds.BASIC]: [
            USER_SCOPES.SERVICE_CONTRACT_CREATE,
            USER_SCOPES.SERVICE_CONTRACT_DEBIT_PAYMENT_READ,
            USER_SCOPES.EXPENDITURE_RECORD_CREATE,
        ],
    }

    public getUserPermissions = (userRoleId: number): string[] => {
        return this.dictionaryOfPermissions?.[userRoleId] || []
    }
}